import type { ExperimentDefinition } from "libs/state/src/lib/experiments";

import { useFeatureFlagsContext } from "./featureFlagsContext";

interface UseFlagVariantOptions {
  formName?: string;
}

/**
 * Returns `true` when the current user is in the `"test"` variant for the
 * given experiment AND the current form is not excluded.
 */
export function useFlagVariant(
  experiment: ExperimentDefinition,
  { formName }: UseFlagVariantOptions = {},
): boolean {
  const { flags } = useFeatureFlagsContext();

  if (experiment.excludeForms?.has(formName ?? "")) {
    return false;
  }

  return flags[experiment.key] === "test";
}
